export default __webpack_public_path__ + "static/media/chalk-line-grey.96dd95b1.svg";